function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.775 20a.777.777 0 01-.548-.225.766.766 0 010-1.088L8.98 10 .227 1.313a.766.766 0 010-1.088.78.78 0 011.096 0l9.302 9.231c.303.3.303.788 0 1.088l-9.302 9.23A.776.776 0 01.775 20z",
  fill: "#FFF",
  fillRule: "nonzero"
});

function SvgTrimFilterCarouselRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgTrimFilterCarouselRight;